import React, { useState, useRef } from 'react'
import {  Radio } from 'antd';     
function WorkWechatSelect(props) {
    const listRef = useRef([]); // 使用 ref 保存最新的 list，避免闭包问题
    const [selectedValue, setSelectedValue] = useState(null);
    
    return (
        <Radio.Group
            options={props.wechat.map(item => {return {value:item.id,label:'(已加' + item.num + ')' + item.name + '(' + item.phone + ')',phone:item.phone,name:item.name}})} 
            value={selectedValue}
            onChange={(e) => {
                // 处理事件对象：可能是直接的值，也可能是事件对象
                let actualValue = e;
                if (e && typeof e === 'object' && e.target) {
                    // 如果是事件对象，从 target.value 获取值
                    actualValue = e.target.value;
                }
                
                setSelectedValue(actualValue);
                
                // 使用 ref 获取最新的 list，避免闭包问题
                const currentList = listRef.current;
                
                // 从 list 中查找对应的选项以获取 label
                // 处理类型匹配问题（value 可能是字符串或数字）
                const selectedOption = currentList.find(item => {
                    // 转换为字符串进行比较，确保类型匹配
                    return String(item.value) === String(actualValue) || item.value === actualValue;
                });
                let name = '';
                let phone = '';
                if (selectedOption) {
                    name = selectedOption.name;
                    phone = selectedOption.phone;
                } else {
                    console.warn('未找到对应的选项，value:', actualValue, '当前 list:', currentList);
                }
                // 修复 name 和 phone 没有数据的问题，直接从 wechatList 查找
                const selectedWechat = props.wechat.find(item => String(item.id) === String(actualValue));
                name = selectedWechat ? selectedWechat.name : '';
                phone = selectedWechat ? selectedWechat.phone : '';
                console.log(actualValue, name, phone);
                props.onChange(actualValue,name,phone)
            }} 
            block
            size='large'
            optionType="button"
            buttonStyle="solid"
            style={{width:'100%'}}
        />
    )
}

export default WorkWechatSelect